import {numberFormat} from 'utils/Helper';

import CampaignStatCard from './components/CampaignStatCard/CampaignStatCard';

type CampaignReportProps = {
  campaign: {
    demand_click_count: number;
    active_click_count: number;
    used_budget: number;
    unused_budget: number;
  };
};

const CampaignReport: React.FC<CampaignReportProps> = ({campaign}) => {
  return (
    <section className="flex flex-col gap-2.5 px-4 pb-4">
      <h2 className="my-4 text-subtitle-md text-neutral-fg">گزارش کمپین</h2>
      <div className="grid grid-cols-2 gap-2.5">
        <CampaignStatCard title="تعداد کلیک درخواستی" value={campaign.demand_click_count} />
        <CampaignStatCard title="تعداد کلیک دریافتی" value={campaign.active_click_count} />
        <CampaignStatCard
          title="هزینه مصرف شده"
          value={`${numberFormat(campaign.used_budget || 0)} تومان`}
        />
        <CampaignStatCard
          title="هزینه مصرف باقی مانده"
          value={`${numberFormat(campaign.unused_budget || 0)} تومان`}
        />
      </div>
    </section>
  );
};

export default CampaignReport;
